import React from "react";
import Banner from "./Banner";
// import banner from "../Images/OurWork/common-banner.jpg";

const Volunteer = () => {
  return (
    <div>
      <Banner name={"Volunteer"} Title={"Volunteer"} />
    </div>
  );
};

export default Volunteer;
